module.exports = __webpack_public_path__ + "e49d52e74b7689a0727def99da31f3eb.ttf";


//////////////////
// WEBPACK FOOTER
// ./portal/css/kiss/fonts/font-kiss/fonts/glyphicons/glyphicons-halflings-regular.ttf
// module id = 307
// module chunks = 9